import { render } from "./RecetaDetalle.vue?vue&type=template&id=0b4cb75c&scoped=true"
import script from "./RecetaDetalle.vue?vue&type=script&lang=js"
export * from "./RecetaDetalle.vue?vue&type=script&lang=js"

import "./RecetaDetalle.vue?vue&type=style&index=0&id=0b4cb75c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b4cb75c"]])

export default __exports__